import { ComponentType, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class ModalService {

    constructor(
        private _dialog: MatDialog,
        private _overlay: Overlay,
        private _injector: Injector,
        private _mediaObserver: MediaObserver 
    ){}

    async call(data:{component:any, data?: {name:string, value:any}[], afterClosed?:Function, width?:string}){
        let dialogRef: MatDialogRef<any>;
        dialogRef = this._dialog.open(data.component, {
            maxWidth: '60vw',
            width: (data.width ? data.width : '40%'),
            panelClass: 'no-padding-dialog'
        });
        if(data.data){
            for(let valuesComponent of data.data){
                dialogRef.componentInstance[valuesComponent.name] = valuesComponent.value;
            }
        }

        dialogRef.afterClosed().subscribe(() => {
            if(data.afterClosed)
                data.afterClosed();
          }
        );
    }

    /**
     * Cria um overlay que abre um componente interno
     * 
     * @author Edgard H. <edgard@tivic.com.br>
     * @param {ModalCreateOptions} options 
     * @returns mixed
     */

    create(options: ModalCreateOptions) {
        const strategy = this._overlay.position().global();
        const overlayRef = this._overlay.create({
            width: options.width || undefined,
            minWidth:( !this._mediaObserver.isActive('xs') ? options.width : '90vw' ),
            height: options.height || undefined,
            minHeight: options.height || 'auto',
            maxWidth: '95vw',
            maxHeight: '100vh',
            hasBackdrop: true,
            positionStrategy: strategy,
        });

        this._backdropOnClick(options, overlayRef);

        const componentRef = new ComponentPortal(options.component, null, Injector.create({
            parent: this._injector,
            providers: [
                { provide: 'MODAL_DATA', useValue: options.data },
                { provide: 'OVERLAY_REF', useValue: overlayRef }
            ]
        }));
        
        strategy.centerHorizontally();
        strategy.centerVertically();

        window.addEventListener('popstate', (event) => {
            overlayRef.detach();
        });

        return {
            overlayRef: () => overlayRef,
            present: () => {
                overlayRef.attach(componentRef);
            },
            dismiss: () => {
                overlayRef.detach();                
            }
        };
    }

    private _backdropOnClick(options: ModalCreateOptions, overlayRef: OverlayRef) {
        if(options && options.onBackDropClick && options.onBackDropClick instanceof Function) {
            overlayRef.backdropClick().subscribe(ob => options.onBackDropClick(ob));
        }
    }
}

interface ModalCreateOptions {
    component: ComponentType<any>,
    width?: number | string,
    height?: number | string,
    data?: any,
    onBackDropClick?(ob: MouseEvent)
}